import { Alert, Anchor, Button, Stack, TextInput } from "@mantine/core";
import { useState } from "react";
import { Link } from "react-router-dom";

import { client, errorMessage, unwrap } from "@/api";

import { AuthCard } from "./AuthCard";

/** /forgot: always answers the same way (the API is silent on unknown emails). */
export function ForgotPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await unwrap(client.POST("/api/v1/auth/password-reset/request", { body: { email: email.trim() } }));
      setSent(true);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthCard title="Reset your password" subtitle="We will email you a link to set a new password.">
      {sent ?
        <Stack>
          <Alert color="green" data-testid="forgot-sent">
            If the address exists, a link was sent. Check your inbox.
          </Alert>
          <Anchor component={Link} to="/login" size="sm">
            Back to sign in
          </Anchor>
        </Stack>
      : <form onSubmit={submit}>
          <Stack>
            <TextInput
              label="Email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
            />
            {error && <Alert color="red">{error}</Alert>}
            <Button type="submit" loading={busy}>
              Send link
            </Button>
            <Anchor component={Link} to="/login" size="sm">
              Back to sign in
            </Anchor>
          </Stack>
        </form>
      }
    </AuthCard>
  );
}
